import React, { memo } from 'react';
import { RadioGroup as MuiRadioGroup } from '@mui/material';
import { Label } from '../Label';
import { RadioButton } from './RadioButton';
export const RadioGroup = memo(({ label = '', required, options, ...props }) => {
    return (React.createElement("div", null,
        label && React.createElement(Label, { required: required }, label),
        React.createElement(MuiRadioGroup, { ...props }, options && options.map(({ id, caption }) => React.createElement(RadioButton, { key: id, label: String(caption), value: id })))));
});
